<template>
  <v-card class="chat-table" elevation="2">
    <v-card-title>
      <div class="table-title">Chats Recentes</div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="chats"
        :loading="loading"
        :items-per-page="10"
        class="elevation-0"
      >
        <template v-slot:item.createdAt="{ item }">
          {{ formatDateTime(item.createdAt || item.created_at) }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="getStatusColor(item)">
            {{ getStatus(item) }}
          </v-chip>
        </template>
        <template v-slot:item.channel="{ item }">
          {{ getChannel(item) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDateTime } from '@/utils/dateHelpers'

export default {
  name: 'ChatTable',
  props: {
    chats: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id', sortable: true },
        { text: 'Data', value: 'createdAt', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Canal', value: 'channel', sortable: true }
      ]
    }
  },
  methods: {
    formatDateTime,
    getStatus (chat) {
      if (chat?.status) return chat.status
      return (chat?.closedAt || chat?.closed_at) ? 'Fechado' : 'Aberto'
    },
    getStatusColor (chat) {
      return this.getStatus(chat) === 'Aberto' ? 'success' : 'grey'
    },
    getChannel (chat) {
      return chat?.channels?.[0]?.type ?? chat?.channel?.type ?? chat?.channel ?? 'N/A'
    }
  }
}
</script>

<style scoped lang="scss">
.chat-table {
  border-radius: 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
}
</style>
